import * as React from 'react';
import ReactTable from 'react-table';
import OAuth, { DataRequest, OAuthClientStatus, Response } from '../api';
import TimeStampPanel from '../panels/timestampPanel';
import { default as Renderers } from '../sys/columns';
import { Button } from 'semantic-ui-react';
import RequestParameters from '../api/parameters';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import CustomPagination from '../sys/pagination';
const fileDownload = require('js-file-download');

const _ = require('lodash');

class State {
    ts?: number;
    firstTime?: boolean;
    message?: string;
}

interface Props {
    refresh?: number;       // refresh data every n millis
    streamid: number;
    streamName: string;
    timerange?: string;
    vod?: boolean;
    mode?: string;
    header ?: boolean;
    audioEnabled ?: boolean;
    videoEnabled ?: boolean;
    pixelEnabled ?: boolean;
}

// maps to a chunk object returned from the Chunks Metadata API
interface Chunk {
    alarms: number[];
    availerr: number;
    availmon: number;
    availstate: number;
    dlbitrate: number;
    downloadTime: number;
    duration: number;
    frbft: number;
    frbsys: number;
    host: string;
    httpstatus: number;
    ipTos: number;
    ipaddr: string;
    path: string;
    rtt: number;
    sequence: number;
    size: number;
    tcpDupAck: number;
    tcpRexmit: number;
    time: number;
    underrun: number;
    vs: number;
}

// we transform the flat chunks array into 15min interval groups
interface ChunkInterval {
    timestamp: number;  // interval timestamp
    chunks: Chunk[];    // chunks within this group
}

export default class MediaFileView extends React.Component<Props, State> {
    public static defaultProps: Partial<Props> = {
        timerange: 'all',
        refresh: 10000,
        vod: false,
        header: true,
        audioEnabled: false,
        videoEnabled: false,
        pixelEnabled: false
    };

    // called by the DataRequest framework after a data fetch so we can transform the flat chunks array into grouped
    // interval collection of chunk objects.
    static transformData(data: any): ChunkInterval[] {
        if (data && data.chunks && Array.isArray(data.chunks.items)) {
            // perform a group-by on the chunks to reorganize into time intervals
            return _.chain(data.chunks.items)
                .groupBy( (chunk: Chunk) => Math.floor(chunk.time / 900) * 900 )    // quantize the timestamps into 15 min intervals
                .map( (value: Chunk[], key: any) => ({
                    timestamp: Number(key),     // for some reason lodash converts key to string
                    chunks: value
                }))
                .value();
        } else return [];
    }

    componentWillMount() {
        this.setState({
            ts: 0,
            firstTime: true,
            message: ''
        });
    }

    render() {
        const { streamid, timerange, vod } = this.props;
        const url = 'api/'
            + (vod ? 'vod/' : 'stream/')
            + streamid + '/metadata/chunks';

        const mediaFileColumns = [{
            Header: 'Request Time',
            width: 130,
            accessor: 'time',
            resizable: false,
            Cell: (props: any) => Renderers.timestamp.format(props.value)
        }, {
            Header: 'URL',
            width: 600,
            accessor: 'path',
            resizable: true,
            Cell: (props: any) => this.hoverRenderer(props.value)
        }, {
            Header: 'Host',
            width: 200,
            accessor: 'host',
            resizable: true,
            Cell: (props: any) => this.hoverRenderer(props.value)
        }, {
            Header: 'IP Address',
            width: 100,
            accessor: 'ipaddr',
            resizable: false
        }, {
            Header: 'HTTP Status',
            width: 100,
            accessor: 'httpstatus',
            resizable: false,
            Cell: (props: any) => {return (<span className="center-aligned">{props.value}</span>); }
        }, {
            Header: 'Sequence',
            width: 160,
            accessor: 'sequence',
            resizable: false,
            Cell: (props: any) => this.hoverRenderer(props.value)
        }, {
            Header: (h: any) => <span className="right-aligned">Duration<br/>(sec)</span>,
            width: 70,
            accessor: 'duration',
            resizable: false,
            Cell: (props: any) => {return (props.value) ? Renderers.secToMsec(props.value) : (<span className="right-aligned">-</span>); }
        }, {
            Header: (h: any) => <span className="right-aligned">Size<br/>(bytes)</span>,
            width: 70,
            accessor: 'size',
            resizable: false,
            Cell: (props: any) => Renderers.commaSeparated(props.value)
        }, {
            Header: (h: any) => <span className="right-aligned">Download<br/>Bit Rate<br/>(kbps)</span>,
            width: 80,
            accessor: 'dlbitrate',
            resizable: false,
            Cell: (props: any) => {return (this.props.mode !== 'Header Only') ? this.renderBitRate(props.value) : (<span className="right-aligned">-</span>); }
        }, {
            Header: (h: any) => <span className="right-aligned">Download<br/>Time<br/>(sec)</span>,
            width: 80,
            accessor: 'downloadTime',
            resizable: false,
            Cell: (props: any) => Renderers.secToMsec(props.value)
        }, {
            Header: (h: any) => <span className="right-aligned">Round Trip<br/>Time<br/>(ms)</span>,
            width: 90,
            accessor: 'rtt',
            resizable: false,
            Cell: (props: any) => Renderers.secToMsec(props.value)
        }, {
            Header: (h: any) => <span className="right-aligned">IP TOS</span>,
            width: 70,
            accessor: 'ipTos',
            resizable: false,
            Cell: (props: any) => Renderers.commaSeparated(props.value)
        }, {
            Header: (h: any) => <span className="right-aligned">TCP<br/>DUP<br/>ACK</span>,
            width: 70,
            accessor: 'tcpDupAck',
            resizable: false,
            Cell: (props: any) => Renderers.commaSeparated(props.value)
        }, {
            Header: (h: any) => <span className="right-aligned">TCP<br/>Retran</span>,
            width: 70,
            accessor: 'tcpRexmit',
            resizable: false,
            Cell: (props: any) => Renderers.commaSeparated(props.value)
        }, {
            Header: (h: any) => <span className="right-aligned">VS</span>,
            width: 50,
            accessor: 'vs',
            resizable: false,
            Cell: (props: any) => this.vsRenderer(props.value)
        }, {
            Header: (h: any) => <span className="right-aligned">FRB-SYS<br/>(sec)</span>,
            width: 80,
            accessor: 'frbsys',
            resizable: false,
            Cell: (props: any) => this.frbSysFTRenderer(props.value)
        }, {
            Header: (h: any) => <span className="right-aligned">FRB-FT<br/>(sec)</span>,
            width: 80,
            accessor: 'frbft',
            resizable: false,
            Cell: (props: any) => this.frbSysFTRenderer(props.value)
        }, {
            Header: (h: any) => <span className="right-aligned">File<br/>Video<br/>MOS</span>,
            width: 80,
            accessor: 'mosFile',
            show: (this.props.audioEnabled || this.props.videoEnabled || this.props.pixelEnabled),
            resizable: false,
            Cell: (props: any) => this.checkQoEMedia(props, null, null)
        }, {
            Header: (h: any) => <span className="right-aligned">Black Screen<br/>(Min/Max/Avg)</span>,
            width: 130,
            accessor: 'blacknessGopAvg',
            show: (this.props.audioEnabled || this.props.videoEnabled || this.props.pixelEnabled),
            resizable: false,
            Cell: (props: any) => this.checkQoEMedia(props, 'blacknessGopMin', 'blacknessGopMax')
        }, {
            Header: (h: any) => <span className="right-aligned">Frame<br/>Error</span>,
            width: 80,
            accessor: 'frameErr',
            show: (this.props.audioEnabled || this.props.videoEnabled || this.props.pixelEnabled),
            resizable: false,
            Cell: (props: any) => this.checkQoEMedia(props, null, null)
        }, {
            Header: (h: any) => <span className="right-aligned">Still Frame<br/>(Min/Max/Avg)</span>,
            width: 130,
            accessor: 'stillnessGopAvg',
            show: (this.props.audioEnabled || this.props.videoEnabled || this.props.pixelEnabled),
            resizable: false,
            Cell: (props: any) => this.checkQoEMedia(props, 'stillnessGopMin', 'stillnessGopMax')
        }, {
            Header: (h: any) => <span className="right-aligned">Pixel Block Artifact<br/>(Min/Max/Avg)</span>,
            width: 160,
            accessor: 'pixelGopAvg',
            show: (this.props.audioEnabled || this.props.videoEnabled || this.props.pixelEnabled),
            resizable: false,
            Cell: (props: any) => this.checkQoEMedia(props, 'pixelGopMin', 'pixelGopMax')
        }, {
            Header: (h: any) => <span className="right-aligned">Audio MOS<br/>(Min/Max/Avg)</span>,
            width: 200,
            accessor: 'mosAudioAvg',
            show: (this.props.audioEnabled || this.props.videoEnabled || this.props.pixelEnabled),
            resizable: false,
            Cell: (props: any) => this.checkQoEMedia(props, 'mosAudioMin', 'mosAudioMax')
        }, {
            Header: (h: any) => <span className="right-aligned">Loudness<br/>(Min/Max/Avg)</span>,
            width: 200,
            accessor: 'audioLoudAvg',
            show: (this.props.audioEnabled || this.props.videoEnabled || this.props.pixelEnabled),
            resizable: false,
            Cell: (props: any) => this.checkQoEMedia(props, 'audioLoudMin', 'audioLoudMax')
        }, {
            Header: (h: any) => <span className="right-aligned">Dialnorm<br/>(Min/Max/Avg)</span>,
            width: 130,
            accessor: 'audioDnAvg',
            show: (this.props.audioEnabled || this.props.videoEnabled || this.props.pixelEnabled),
            resizable: false,
            Cell: (props: any) => this.checkQoEMedia(props, 'audioDnMin', 'audioDnMax')
        }, {
            Header: (h: any) => <span className="right-aligned">Dialnorm Deviation<br/>(Min/Max/Avg)</span>,
            width: 160,
            accessor: 'audioLdDnDevAvg',
            show: (this.props.audioEnabled || this.props.videoEnabled || this.props.pixelEnabled),
            resizable: false,
            Cell: (props: any) => this.checkQoEMedia(props, 'audioLdDnDevMin', 'audioLdDnDevMax')
        }, {
            Header: (h: any) => <span className="center-aligned">Silence</span>,
            width: 175,
            accessor: 'audioSilenCh',
            show: (this.props.audioEnabled || this.props.videoEnabled || this.props.pixelEnabled),
            resizable: false,
            Cell: (props: any) => this.checkQoEMedia(props, null, null)
        }];

        return (
            <div className="view-content" id="media">
                {(this.props.header === true) ?
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">Media File Statistics</div>
                        </div>
                    </div>
                </div> : '' }
                {(this.props.header === true) ?
                <OAuth.Context>{(oauth: OAuthClientStatus) => (
                    <div className="filterPanel">
                        <h5>{this.props.streamName}</h5>
                        <div className="right-align-label-red">
                            {this.state.message}
                        </div>
                        <Button
                            className="filter-panel-rightButton"
                            title="Export Media File Stats File"
                            content="Export"
                            onClick={(event, data) => this.exportLog(oauth, streamid, timerange)}
                        />
                    </div>
                )}</OAuth.Context> :
                    <OAuth.Context>{(oauth: OAuthClientStatus) => (
                        <div className="filterPanel">
                            <Button
                                className="filter-panel-rightButton"
                                title="Export Media File Stats File"
                                content="Export"
                                onClick={(event, data) => this.exportLog(oauth, streamid, timerange)}
                            />
                        </div>
                    )}</OAuth.Context> }
                    <DataRequest
                        auto                // automatically request on data change (filter change)
                        spinner             // show spinner when foreground loading (ex. on first load)
                        debounce={350}      // debounce multiple requests (i.e. as user types in filter box)
                        interval={this.props.refresh}
                        method="post"
                        endpoint={url}
                        transform={MediaFileView.transformData}     // groups our flat array of chunks into intervals
                        data={{
                            streams: streamid,
                            timerange
                        }}
                    >{ (request: Response) => {
                        // find the selected interval in the array of data (or default to first interval)
                        const index = request.data &&
                            request.data.findIndex( (ci: ChunkInterval) => ci.timestamp === this.state.ts ) || 0;

                        if (index === -1) {
                            if (this.state.firstTime) {
                                this.setState({
                                    firstTime: false
                                });
                            }
                            if (request.data.length !== 0) {
                                this.setState({
                                  ts: request.data[request.data.length - 1].timestamp
                                });
                            }
                        }

                        // get the interval object
                        const selectedInterval = (Array.isArray(request.data) && index < request.data.length)
                            ? request.data[ (index >= 0) ? index : 0]
                            : undefined;

                        return (
                            <div className="dividedArea">
                                <div className="fixedWidth">
                                    <TimeStampPanel
                                        ref="assets"
                                        className="timestamp-panel-mediaFile"
                                        header="Interval"
                                        activeTs={this.state.ts}
                                        data={(request && request.data) ? request.data : []}
                                        onClick={(ts: number, i: number) => {
                                            this.setState({
                                              ts: ts
                                            });
                                        }}
                                    />
                                </div>
                                {!this.props.vod &&
                                <ReactTable
                                    className="media-file -striped -highlight"
                                    onFetchData={request.refresh}
                                    loading={request.spinner}
                                    NoDataComponent={request.spinner ? () => null : undefined}
                                    data={selectedInterval && selectedInterval.chunks || []}
                                    columns={mediaFileColumns}
                                    pageSize={18}
                                    // PaginationComponent={CustomPagination}
                                    showPageSizeOptions={false}
                                    showPagination={true}
                                />
                                }
                                {this.props.vod &&
                                <ReactTable
                                    className="transaction-log -striped -highlight outside-scroll"
                                    onFetchData={request.refresh}
                                    loading={request.spinner}
                                    NoDataComponent={request.spinner ? () => null : undefined}
                                    data={selectedInterval && selectedInterval.chunks || []}
                                    columns={mediaFileColumns}
                                    defaultPageSize={10}
                                    style={{
                                        height: '525px',
                                        width: '1600px'
                                    }}
                                    PaginationComponent={CustomPagination}
                                    // showPageSizeOptions={false}
                                    // showPagination={true}
                                />
                                }
                            </div>
                        );
                    }}
                    </DataRequest>
            </div>
        );
    }

    vsRenderer(value: any): React.ReactNode {
        if (value === 0) {
            return (
                <div className="right-aligned">-</div>
            );
        } else {
            return (
            <span className="right-aligned">{value}</span>
            );
        }
    }
    hoverRenderer(value: any): React.ReactNode {
        return (
            <div title={value}>{value}</div>
        );
    }

    frbSysFTRenderer(value: any): React.ReactNode {
        if (value === 0 || value === null || value === undefined) {
            return (
                <div className="right-aligned">-</div>
            );
        } else {
            let val = (value / 1000).toFixed(2);
            return (
            <span className="right-aligned">{val}</span>
            );
        }
    }

    renderBitRate(value: any): React.ReactNode {
        return Renderers.bytesToKB(value);
    }

    countAudioChannel(value: any): React.ReactNode {
        // audioFL?: boolean;  // 0x01  = 1
        // audioFC?: boolean;  // 0x02  = 2
        // audioFR?: boolean;  // 0x04  = 4
        // audioRL?: boolean;  // 0x10  = 16
        // audioRR?: boolean;  // 0x20  = 32
        // audioLFE?: boolean; // 0x100 = 256 (311 total)

        // let clsName = '';
        let audioString = '';

        switch (value) {
            case 0:
                audioString = '-';
                break;
            case 1:
                audioString = 'FL';
                break;
            case 2:
                audioString = 'FC';
                break;
            case 3:
                audioString = 'FL,FC';
                break;
            case 4:
                audioString = 'FR';
                break;
            case 5:
                audioString = 'FL,FR';
                break;
            case 6:
                audioString = 'FC,FR';
                break;
            case 7:
                audioString = 'FL,FC,FR';
                break;
            case 16:
                audioString = 'RL';
                break;
            case 17:
                audioString = 'FL,RL';
                break;
            case 18:
                audioString = 'FC,RL';
                break;
            case 19:
                audioString = 'FL,FC,RL';
                break;
            case 20:
                audioString = 'FR,RL';
                break;
            case 21:
                audioString = 'FL,FR,RL';
                break;
            case 22:
                audioString = 'FC,FR,RL';
                break;
            case 23:
                audioString = 'FL,FC,FR,RL';
                break;
            case 32:
                audioString = 'RR';
                break;
            case 33:
                audioString = 'FL,RR';
                break;
            case 34:
                audioString = 'FC,RR';
                break;
            case 35:
                audioString = 'FL,FC,RR';
                break;
            case 36:
                audioString = 'FR,RR';
                break;
            case 37:
                audioString = 'FL,FR,RR';
                break;
            case 38:
                audioString = 'FC,FR,RR';
                break;
            case 39:
                audioString = 'FL,FC,FR,RR';
                break;
            case 48:
                audioString = 'RL,RR';
                break;
            case 49:
                audioString = 'FL,RL,RR';
                break;
            case 50:
                audioString = 'FC,RL,RR';
                break;
            case 51:
                audioString = 'FL,FC,RL,RR';
                break;
            case 52:
                audioString = 'FR,RL,RR';
                break;
            case 53:
                audioString = 'FL,FR,RL,RR';
                break;
            case 54:
                audioString = 'FC,FR,RL,RR';
                break;
            case 55:
                audioString = 'FL,FC,FR,RL,RR';
                break;
            case 256:
                audioString = 'LFE';
                break;
            case 257:
                audioString = 'FL,LFE';
                break;
            case 258:
                audioString = 'FC,LFE';
                break;
            case 259:
                audioString = 'FL,FC,LFE';
                break;
            case 260:
                audioString = 'FR,LFE';
                break;
            case 261:
                audioString = 'FL,FR,LFE';
                break;
            case 262:
                audioString = 'FC,FR,LFE';
                break;
            case 263:
                audioString = 'FL,FC,FR,LFE';
                break;
            case 272:
                audioString = 'RL,LFE';
                break;
            case 273:
                audioString = 'FL,RL,LFE';
                break;
            case 274:
                audioString = 'FC,RL,LFE';
                break;
            case 275:
                audioString = 'FL,FC,RL,LFE';
                break;
            case 276:
                audioString = 'FR,RL,LFE';
                break;
            case 277:
                audioString = 'FL,FR,RL,LFE';
                break;
            case 278:
                audioString = 'FC,FR,RL,LFE';
                break;
            case 279:
                audioString = 'FL,FC,FR,RL,LFE';
                break;
            case 288:
                audioString = 'RR,LFE';
                break;
            case 289:
                audioString = 'FL,RR,LFE';
                break;
            case 290:
                audioString = 'FC,RR,LFE';
                break;
            case 291:
                audioString = 'FL,FC,RR,LFE';
                break;
            case 292:
                audioString = 'FR,RR,LFE';
                break;
            case 293:
                audioString = 'FL,FR,RR,LFE';
                break;
            case 294:
                audioString = 'FC,FR,RR,LFE';
                break;
            case 295:
                audioString = 'FL,FC,FR,RR,LFE';
                break;
            case 304:
                audioString = 'RL,RR,LFE';
                break;
            case 305:
                audioString = 'FL,RL,RR,LFE';
                break;
            case 306:
                audioString = 'FC,RL,RR,LFE';
                break;
            case 307:
                audioString = 'FL,FC,RL,RR,LFE';
                break;
            case 308:
                audioString = 'FR,RL,RR,LFE';
                break;
            case 309:
                audioString = 'FL,FR,RL,RR,LFE';
                break;
            case 310:
                audioString = 'FC,FR,RL,RR,LFE';
                break;
            case 311:
                audioString = 'FL,FC,FR,RL,RR,LFE';
                break;
            default:
                audioString = '-';
                break;
        }

        return audioString;
    }

    checkQoEMedia(props: any, minValue: any, maxValue: any): React.ReactNode {
        const audioQoECols = ['mosFile', 'mosAudioAvg', 'audioLoudAvg', 'audioDnAvg', 'audioLdDnDevAvg', 'audioSilenCh'];
        const videoQoECols = ['blacknessGopAvg', 'frameErr', 'stillnessGopAvg'];
        const pixelQoECols = ['pixelGopAvg'];

        const decimalValues = ['mosFile', 'mosAudioAvg', 'audioLoudAvg'];
        const isDecimal = decimalValues.includes(props.column.id);

        let value = props.value || props.value === 0 ? isDecimal ? props.value.toFixed(2) : props.value : '-';

        if (!this.props.audioEnabled && audioQoECols.includes(props.column.id)) {
            value = '-';
        }
        if (!this.props.videoEnabled && videoQoECols.includes(props.column.id)) {
            value = '-';
        }
        if (!this.props.pixelEnabled && pixelQoECols.includes(props.column.id)) {
            value = '-';
        }

        if (minValue && maxValue) {
            if (value === '-') {
                value = '-/-/-';
            } else {
                let maxV = isDecimal ? props.original[maxValue].toFixed(2) : props.original[maxValue];
                let minV = isDecimal ? props.original[minValue].toFixed(2) : props.original[minValue];
                value = `${minV}/${maxV}/${value}`;
            }
        }
        if (props.column.id === 'audioSilenCh') {
            value = this.countAudioChannel(props.value);
            return (
                <span className="center-aligned">{value}</span>
            );
        } else {
            return (
                <span className="right-aligned">{value}</span>
            );
        }
    }

    exportLog(oauth: OAuthClientStatus, streamid: number, timerange: any) {
        let _this = this;
        let now = new Date(); let filename = '';
        let url = (oauth.secureHost ? 'https' : 'http') + '://default/api/export';
        if (oauth.sys.name && oauth.sys.name.length !== 0) {
            // let sysname = encodeURIComponent(oauth.sys.name);
            filename = 'IQMediaFileStatsLog-' + oauth.sys.name + '-';
        } else {
            filename = 'IQMediaFileStatsLog-';
        }
        filename += (now.getFullYear() + ('0' + (now.getUTCMonth() + 1)).slice(-2) + ('0' + now.getDate()).slice(-2));
        filename += '-';
        filename += (('0' + now.getHours()).slice(-2) + ('0' + now.getMinutes()).slice(-2) + ('0' + now.getSeconds()).slice(-2));
        filename += '.tsv';

        const params = new RequestParameters({
            dataType: 'MediaFileStats',
            exportFormat: 'tsv',
            filename: filename,
            streams: streamid,
            isVod: this.props.vod,
            timerange
        }).queryString();

        if (params.length > 0)
            url += '?' + params;

        _this.setState({
            message: ''
        });
        axios.post(url)
            .then(function (response: AxiosResponse) {
                if (response.data.code !== undefined) { // FAILURE
                    _this.setState({
                      message: 'Export: ' + response.data.det
                    });
                } else {
                    let stringObject = response.data;
                    fileDownload(stringObject, filename);
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('Export Media File Stats Log error: ', error);
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/media-file-stats.tsx